import { takeLatest, put, call } from 'redux-saga/effects';

import { CONFIG_SESSION } from '@handler/common/startSession';
import { storage } from '@commons/storage';
import { formatDateDDMMYYYY } from '@components/common/format';
import {
  GET_LOADING_PLANEJAMENTO_SUCCESS,
  GET_LOADING_PLANEJAMENTO_PENDING,
  RELATORIO_ATIVIDADES_PLANEJAMENTO_TALHAO_SINTETICO,
} from '../actionTypes';
import { CONST_FILTER_PLANEJAMENTO } from '@commons/consts';
import { getRelatorioAtividadesPlanejamentoTalhaoSintetico } from '../service';

function* sagaRelatorioAtividadesTalhaoSinteticoPlanejamento(action) {
  yield put({ type: GET_LOADING_PLANEJAMENTO_PENDING })

  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;
    const idSafraAtiva = JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva?.id ?? -1;

    let filterSaved = sessionStorage.getItem(CONST_FILTER_PLANEJAMENTO) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_PLANEJAMENTO)) : null;

    const datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

    yield call(getRelatorioAtividadesPlanejamentoTalhaoSintetico, idFazenda, idSafraAtiva, datas, filterSaved.where, action.mostrarCusto ?? false)

    yield put({
      type: GET_LOADING_PLANEJAMENTO_SUCCESS
    });
  } catch (error) {
    yield put({ type: GET_LOADING_PLANEJAMENTO_SUCCESS })
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchRelatorioAtividadesTalhaoSinteticoPlanejamento() {
  yield takeLatest(RELATORIO_ATIVIDADES_PLANEJAMENTO_TALHAO_SINTETICO, sagaRelatorioAtividadesTalhaoSinteticoPlanejamento)
}